<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Marketers')"
          :description="$t('From Here You Can Control The Marketers')"
        />
        <indexTable
          :searchText="$t('Search For A Marketer')"
          :emptyTableText="$t('There Are No Marketers')"
          :buttonRole="true"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            {
              column: 'name',
              title: $t('Marketer name'),
              type: 'text',
              sort: true
            },
            {
              column: 'balance',
              title: $t('Balance'),
              type: 'text',
              sort: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: true },
                { name: 'delete', role: true }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/marketers'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
